import { postApi } from 'api/fetchApi'
import { operations } from 'api/generated/messenger_outside_contacts'

type Operation =
  operations['messenger_outside_contacts_send_contact_sendContact']
type Response = Operation['responses']['200']['schema']
type Body = Operation['parameters']['body']['body']

export const sendOutsideContactApi = (
  contactUserId: number,
  serviceAlias: string,
  action: SendOutsideContactStatistics
) => {
  return postApi<Response, Body>('/messenger/outsideContacts/sendContact', {
    contactUserId,
    serviceAlias,
    action,
  })
}

/** Параметр для статистики */
export enum SendOutsideContactStatistics {
  /** Контакт отправлен с экрана добавления */
  Add = 'add',
  /** Контакт отправлен с экрана редактирования */
  Edit = 'edit',
  /** Контакт отправлен по клику из панели контактов в чате */
  Send = 'send',
}
